import {
  createTableDefinition,
  type TableDefinition,
} from '@/features/shared/components/tableSystem/tableDefinition';
import { getDetailLabel } from '@/shared/copy/details';

export type CoverageRunsSortKey =
  | 'projectName'
  | 'linesPct'
  | 'functionsPct'
  | 'branchesPct'
  | 'statementsPct'
  | 'createdAt';

export const coverageRunsTableDefinition: TableDefinition<CoverageRunsSortKey, 'unused'> =
  createTableDefinition({
    title: 'Coverage Runs',
    searchAriaLabel: 'Search coverage runs by project name',
    columns: [
      { field: 'run', label: getDetailLabel('run'), mandatory: true, defaultVisible: true },
      { field: 'failureTaxonomy', label: 'Failure Taxonomy', defaultVisible: true },
      { field: 'lineCoverage', label: 'Line Coverage', defaultVisible: true },
      { field: 'functionCoverage', label: 'Function Coverage', defaultVisible: true },
      { field: 'branchCoverage', label: 'Branch Coverage', defaultVisible: true },
      { field: 'statementCoverage', label: 'Statement Coverage', defaultVisible: true },
      { field: 'details', label: getDetailLabel('details'), defaultVisible: true },
      { field: 'actions', label: getDetailLabel('actions'), defaultVisible: true },
    ],
    defaultSortKey: 'createdAt',
    defaultSortDirection: 'desc',
    sortOptions: [
      { key: 'createdAt', label: 'Captured' },
      { key: 'projectName', label: getDetailLabel('run') },
      { key: 'linesPct', label: 'Line coverage' },
      { key: 'functionsPct', label: 'Function coverage' },
      { key: 'branchesPct', label: 'Branch coverage' },
      { key: 'statementsPct', label: 'Statement coverage' },
    ],
    sortFieldMap: {
      projectName: 'projectName',
      linesPct: 'linesPct',
      functionsPct: 'functionsPct',
      branchesPct: 'branchesPct',
      statementsPct: 'statementsPct',
      createdAt: 'createdAt',
    },
    statusOptions: [],
  });
